"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReverseMortgagePropertyTitleHeld = void 0;
var ReverseMortgagePropertyTitleHeld;
(function (ReverseMortgagePropertyTitleHeld) {
    ReverseMortgagePropertyTitleHeld["FEE_SIMPLE"] = "Fee Simple";
    ReverseMortgagePropertyTitleHeld["LEASEHOLD"] = "Leasehold";
    ReverseMortgagePropertyTitleHeld["LIVING_TRUST"] = "Living Trust";
    ReverseMortgagePropertyTitleHeld["LIFE_ESTATE"] = "Life Estate";
    ReverseMortgagePropertyTitleHeld["NOT_SURE"] = "Not Sure";
})(ReverseMortgagePropertyTitleHeld = exports.ReverseMortgagePropertyTitleHeld || (exports.ReverseMortgagePropertyTitleHeld = {}));
